// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_il-0";